var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfmpeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 20,
    role: "img",
    "aria-label": "FFmpeg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FFmpeg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 53,
    height: 20,
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    href: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNWNiODVjIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+RkZtcGVnPC90aXRsZT48cGF0aCBkPSJNMjEuNzIgMTcuOTFWNi41bC0uNTMtLjQ5TDkuMDUgMTguNTJsLTEuMjktLjA2TDI0IDEuNTNsLS4zMy0uOTUtMTEuOTMgMS01Ljc1IDYuNnYtLjIzbDQuNy01LjM5LTEuMzgtLjc3LTkuMTEuNzd2Mi44NWwxLjkxLjQ2di4wMWwuMTktLjAxLS41Ni42NnYxMC42Yy42MDktLjEyNiAxLjIyLS4yNDEgMS44My0uMzZMMTQuMTIgNS4yMmwuODMtLjA0TDAgMjEuNDRsOS42Ny44MiAxLjM1LS43NyA2LjgyLTYuNzR2Mi4xNWwtNS43MiA1LjU3IDExLjI2Ljk1LjM1LS45NHYtMy4xNmwtMy4yOS0uMThjLjQzNC0uNDAzLjg1OC0uODE2IDEuMjgtMS4yM3oiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 495,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 430
  }, "FFmpeg"), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 430
  }, "FFmpeg"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfmpeg);
export default __webpack_public_path__ + "static/media/ffmpeg.1cbcd491b67b6307f7a0f3f633b44cea.svg";
export { ForwardRef as ReactComponent };